
export const ExportDataAsExcelBase = {
    shouldRowBeSkipped: ((params: any) => {
        const page = params.api.paginationGetCurrentPage();
        const pageSize = params.api.paginationGetPageSize();
        const left = page * pageSize;
        const right = left + pageSize;
        const index = params.node.rowIndex || 0;

        return !(index >= left &&  index <= right);
    }),
}